import {
  createPlatformLocaleMetadata,
  type SupportedPlatformLocale,
} from '@bright-web-skeleton/shared';

export interface PlatformLocaleAuthClient {
  updateUser(attributes: { data: Record<string, unknown> }): Promise<{
    data: { user: unknown | null };
    error: { message?: string } | null;
  }>;
}

/**
 * Persist one explicit platform-language choice through Supabase Auth metadata.
 * The returned authenticated user is the canonical refreshed state.
 */
export async function updateAuthenticatedPlatformLocale(
  authClient: PlatformLocaleAuthClient,
  existingMetadata: Record<string, unknown> | null | undefined,
  locale: SupportedPlatformLocale,
): Promise<unknown> {
  const metadata = createPlatformLocaleMetadata(existingMetadata, locale);
  const { data, error } = await authClient.updateUser({ data: metadata });

  if (error) throw error;
  if (!data.user) {
    throw new Error('Platform language update did not return an authenticated user');
  }

  return data.user;
}
